import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
} from "@angular/core";
import { faCaretRight, faCaretDown } from "@fortawesome/pro-solid-svg-icons";
import { CustomSkeletonConfig } from "src/app/shared/custom-skeleton/custom-skeleton-model";
import {
  EntityGroup,
  OtherSelectedDetails,
} from "src/app/store/models/industry-page.model";
import { MegaMenuService } from "../mega-menu.service";

@Component({
  selector: "app-industry-geography-filter",
  templateUrl: "./industry-geography-filter.component.html",
  styleUrls: ["./industry-geography-filter.component.scss"],
})
export class IndustryGeographyFilterComponent implements OnInit {
  @Output() geographySelect: EventEmitter<any> = new EventEmitter();
  @Input() popularGeography: EntityGroup;
  @Input() otherGeographies: Array<EntityGroup>;
  @Input() popularSelected: Set<number> = new Set();
  @Input() otherSelected: OtherSelectedDetails;
  @Input() allGeography: any;
  @Input() isMegaMenuReady: boolean;

  skeletonDefaultConfig: CustomSkeletonConfig = {
    skeletonType: "list",
    config: {
      list: {
        noOfListItems: 24,
      },
    },
  };
  otherSelectedArray = [];
  isPopularExpanded = true;
  otherGeoExpandedKeys = [];
  faCaretRight = faCaretRight;
  faCaretDown = faCaretDown;
  constructor(private megaMenuService: MegaMenuService) {}
  ngOnInit() {
    if (this.otherSelected) {
      this.setOtherSelectedArray();
    }
    if (this.popularGeography && this.popularSelected) {
      this.setCheckboxAttributes();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.otherSelected &&
      changes.otherSelected.previousValue !== changes.otherSelected.currentValue
    ) {
      this.setOtherSelectedArray();
    }
    if (
      changes.popularSelected &&
      changes.popularSelected.previousValue !==
        changes.popularSelected.currentValue
    ) {
      this.setCheckboxAttributes();
    }
    this.otherGeoExpandedKeys = [...this.otherGeoExpandedKeys];
  }

  onOtherGeoExpand(event) {
    this.otherGeoExpandedKeys = event.keys;
  }
  onAllGeographyChange(isChecked) {
    if (isChecked) {
      this.geographySelect.emit({
        regions: [this.allGeography.key],
        countries: [],
      });
    } else {
      this.geographySelect.emit({ regions: [], countries: [] });
    }
  }

  setOtherSelectedArray() {
    if (this.otherSelected && this.otherSelected.countries) {
      this.otherSelectedArray = [...Array.from(this.otherSelected.countries)];
    }
    if (this.otherSelected && this.otherSelected.regions) {
      this.otherSelectedArray = [
        ...this.otherSelectedArray,
        ...Array.from(this.otherSelected.regions),
      ];
    }
  }
  setCheckboxAttributes() {
    const _popularGeographyChildren = [];
    this.popularGeography &&
      this.popularGeography.children.forEach((countryObj) => {
        const country = { ...countryObj };
        (country as any).isSelected = (country.key as any).every((id) =>
          this.popularSelected.has(id),
        );
        (country as any).isInDeterminate = (country as any).partially_selected;
        // countryObj = {...country}
        _popularGeographyChildren.push(country);
      });
    this.popularGeography.children = _popularGeographyChildren;
  }
  onOtherGeographyChange(data) {
    const regions = [],
      countries = [];
    let isAllGeographySelected = false;
    data.checkedKeys.forEach((item) => {
      if (item.level === 0) {
        regions.push(item.key);
      } else {
        countries.push(item.key);
      }
    });

    isAllGeographySelected = this.megaMenuService.checkAllGeographyStatus(
      regions,
      this.otherGeographies,
    );

    this.geographySelect.emit({ regions, countries, isAllGeographySelected });
  }

  expandPopular(isExpanded: boolean) {
    this.isPopularExpanded = isExpanded;
  }
  onPopularGeographyChange(isChecked, countryObj) {
    let isAllGeographySelected = false;
    if (isChecked) {
      // for the case when the checkbox was selected
      // First add the country id's in key to other selected countries
      // then for each parent region id, check if that region's countries are there in selected countries
      // then mark the region as selected and remove the countries from selected countries list
      countryObj.key.forEach((countryKey) =>
        this.otherSelected.countries.add(countryKey),
      );
      countryObj.parent_region_ids.forEach((parent) => {
        const parentRegions = this.otherGeographies.filter(
          (region) => region.key === parent,
        );
        parentRegions.forEach((region) => {
          const countryKeys = region.children.map((country) => country.key);
          if (
            countryKeys.every((countryId) =>
              this.otherSelected.countries.has(countryId),
            )
          ) {
            this.otherSelected.regions.add(region.key);
            countryKeys.forEach((countryId) =>
              this.otherSelected.countries.delete(countryId),
            );
          }
        });
      });
      isAllGeographySelected = this.megaMenuService.checkAllGeographyStatus(
        Array.from(this.otherSelected.regions),
        this.otherGeographies,
      );
    } else {
      // for the case checkbox was unselected
      // First delete the country id's in key from other selected countries
      // then check if its parent regions were there in other selected regions then remove these regions
      //  from selected list and add all other countries to selected countries list.
      countryObj.key.forEach((countryKey) =>
        this.otherSelected.countries.delete(countryKey),
      );
      countryObj.parent_region_ids.forEach((parent) => {
        const parentRegions = this.otherGeographies.filter(
          (region) => region.key === parent,
        );
        if (this.otherSelected.regions.has(parent)) {
          this.otherSelected.regions.delete(parent);
          const countryKeys = parentRegions[0].children.map(
            (country) => country.key,
          );
          const filteredCountryKeys = countryKeys.filter(
            (cKey) => countryObj.key.indexOf(cKey) === -1,
          );
          filteredCountryKeys.forEach((key) =>
            this.otherSelected.countries.add(key),
          );
        }
      });
    }
    this.geographySelect.emit({
      regions: this.otherSelected.regions,
      countries: this.otherSelected.countries,
      isAllGeographySelected,
    });
  }
}
